import type { UpdateMFAPreferenceInput } from 'aws-amplify/auth';

import type { CognitoMfaType } from './cognitoSignIn';

export const PREFERENCE_KEY: Record<CognitoMfaType, keyof UpdateMFAPreferenceInput> = {
  TOTP: 'totp',
  SMS: 'sms',
  EMAIL: 'email',
};

/**
 * One two-factor method at a time (ENG-6323): `type` becomes the preferred
 * factor and every factor in `turnOff` is disabled, in a single preference
 * update, so the account never ends up with none.
 */
export function preferOnly(
  type: CognitoMfaType,
  turnOff: readonly CognitoMfaType[] = []
): UpdateMFAPreferenceInput {
  const input: UpdateMFAPreferenceInput = { [PREFERENCE_KEY[type]]: 'PREFERRED' };
  for (const other of turnOff) {
    if (other !== type) input[PREFERENCE_KEY[other]] = 'DISABLED';
  }
  return input;
}
